module.exports = __webpack_public_path__ + "97708ab10f0119de2ac8bfcc366f3543.svg";